import React from "react";

import { useTranslation } from "react-i18next";

import { CaretRightIcon } from "@phosphor-icons/react";

import type { MarkerPoint, Marker } from "@local-logic/maps";

import { PopupContent } from "../PopupContent";

import * as styles from "./styles";

export function ClusterPopupContent({
  activeMarker,
  onMarkerSelected,
  onClose,
}: {
  activeMarker?: MarkerPoint;
  onMarkerSelected?: (marker: Marker) => void;
  onClose?: () => void;
}) {
  const { t } = useTranslation(["common"]);

  if (!activeMarker || activeMarker.markers.length < 2) {
    return null;
  }

  return (
    <PopupContent
      title={t("common:map.cluster.poiCount", {
        count: activeMarker.markers.length,
      })}
      secondaryTitleStyle
      onClose={onClose}
    >
      <div className={styles.container} data-testid="cluster-popup-content">
        <ul className={styles.list}>
          {activeMarker.markers.map((marker) => (
            <li
              key={`marker-popup-list-${marker.id}`}
              className={styles.item}
              data-testid="marker-popup-list-item"
            >
              <button
                className={styles.button}
                onClick={() => onMarkerSelected?.(marker)}
                data-testid={`marker-popup-item-button-${marker.id}`}
              >
                <span className={styles.itemText}>{marker.name}</span>{" "}
                <CaretRightIcon weight="bold" className={styles.icon} />
              </button>
            </li>
          ))}
        </ul>
      </div>
    </PopupContent>
  );
}
